
import { Component, Vue } from 'vue-property-decorator'
import { WPXFormValue } from '@/components/templates/WPXForm';
import { CreateNationalEventForm } from '@/services/Calendar/NationalEvents/forms/CreateNationalEventForm';
import NationalEventsRepository from '@/services/Calendar/NationalEvents';

@Component({
  inject: [
    'nationalEventsRepository',
  ],
})
export default class CreateRecurringEvent extends Vue {
  private readonly nationalEventsRepository!: NationalEventsRepository;

  private loading: boolean = true;
  private dateMenu: boolean = false;
  private movableMethods: Array<{ method: string, name: string }> = [];

  private form: WPXFormValue<CreateNationalEventForm> = new WPXFormValue(CreateNationalEventForm);

  private async created(): Promise<void> {
    const methods = await this.nationalEventsRepository.getAllMovableMethods();
    this.movableMethods = methods.map((method) => {
      return { method, name: method.replace('movable', 'Calculate').replace(/([A-Z])/g, ' $1').trim() }
    });
    this.loading = false;
  }

  private async createRecurringEvent(): Promise<void> {
    try {
      await this.nationalEventsRepository.createNationalEvent({
        name: this.form.data.name,
        localName: this.form.data.localName,
        isFixedDate: this.form.data.isFixedDate,
        date: new Date(this.form.data.date),
        movableMethod: this.form.data.movableMethod,
      });

      this.$successDialog.show(`Recurring event '${this.form.data.name}' has been created.`);

      this.formReset();
    } catch (err) {
      this.$errorDialog.show(err.response.data.message);
    }
  }

  private formReset(): void {
    this.form.data.name = '';
    this.form.data.localName = '';
    this.form.data.date = '';
    this.form.data.isFixedDate = true;
    this.form.data.movableMethod = '';
  }
}
